import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OriginEnum } from '@sc/pas-common';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
var OldCarQuotationComponent = /** @class */ (function () {
    function OldCarQuotationComponent(changeDetector, router) {
        this.changeDetector = changeDetector;
        this.router = router;
        this.isLoading = false;
        this.insuring = false;
    }
    OldCarQuotationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setRouteIframe();
        this.state$ = new Subject();
        this.onMessageReceived().subscribe(function (val) {
            var state = val.state;
            if (state) {
                _this.iframeState = state;
                _this.insuring = state !== 'closed';
                _this.isLoading = false;
                if (!_this.changeDetector['destroyed']) {
                    _this.changeDetector.markForCheck();
                }
            }
            if (val.hasOwnProperty('newQuotation')) {
                _this.isLoading = true;
                var hash = localStorage.getItem('hash');
                var hashParameter = hash ? "&p=" + hash : '';
                var categoryParameter = val.categoryKey ? "&categoryKey=" + val.categoryKey : '';
                var iframeSource = _this.polizaURL + "#/auth?tk=" + _this.token + "&fromHome=true" + hashParameter + "&new=true" + categoryParameter;
                _this.iframeSource = iframeSource;
            }
            if (val.hasOwnProperty('closeLateralMenu')) {
                _this.isLoading = false;
            }
            if (val.action === 'dismiss') {
                if (val.openViewPolicy) {
                    _this.router.navigate(["./detalle-poliza/ver/" + val.policyNumber + "/" + OriginEnum.briefcaseList]);
                }
                _this.closePoliza();
            }
            if (val.hasOwnProperty('open')) {
                window.parent.postMessage({ loading: true }, '*');
                var hash = localStorage.getItem('hash');
                _this.iframeSource = _this.polizaURL + '#/auth?tk=' + _this.token + '&fromHome=true' + (hash ? '&p=' + hash : '') +
                    (val.open ? '&id=' + val.open : '&new=true') + (val.idLite ? '&idLite=' + val.idLite : '');
            }
            if (val.hasOwnProperty('opportunityId')) {
                _this.buildIframeUrl(val);
            }
        });
        this.token = localStorage.getItem('tk');
        if (this.token) {
            var reset = localStorage.getItem('reset');
            if (reset) {
                localStorage.removeItem('reset');
            }
        }
        this.setIframeObserver(this.polizaIframe);
    };
    OldCarQuotationComponent.prototype.buildIframeUrl = function (value) {
        window.parent.postMessage({ loading: true }, '*');
        var hash = localStorage.getItem('hash');
        this.iframeSource = this.polizaURL + "#/auth?tk=" + this.token + "&fromHome=true" + (hash ? '&p=' + hash : '') + (value.open ? '&id=' + value.open : '&new=true') + (value.opportunityId ? '&opportunityId=' + value.opportunityId : '') + (value.branchOffice ? '&branchOffice=' + value.branchOffice : '') + (value.number ? '&number=' + value.number : '') + (value.organizerNumber ? '&organizerNumber=' + value.organizerNumber : '');
    };
    OldCarQuotationComponent.prototype.onPolizaLoaded = function () {
        if (!this.changeDetector['destroyed']) {
            this.changeDetector.markForCheck();
        }
    };
    OldCarQuotationComponent.prototype.handleNewQuotation = function () {
        this.isLoading = true;
        window.parent.postMessage({ openSelector: true, insuranceCoreNameByUser: 'DYNAMO', openMenu: true }, '*');
    };
    OldCarQuotationComponent.prototype.setRouteIframe = function () {
        this.polizaURL = environment.server.web.poliza;
        this.iframeSource = this.polizaURL;
    };
    OldCarQuotationComponent.prototype.onMessageReceived = function () {
        return new Observable(function (observer) {
            window.addEventListener('message', function (event) {
                if (typeof (event.data) !== 'undefined') {
                    observer.next(event.data);
                }
            });
        });
    };
    OldCarQuotationComponent.prototype.closePoliza = function () {
        var _this = this;
        this.state$.next({ state: 'closed' });
        this.iframeState = 'closed';
        setTimeout(function () {
            _this.insuring = false;
            _this.loadingPolicy = false;
            _this.iframeSource = _this.polizaURL;
            _this.isLoading = false;
            if (!_this.changeDetector['destroyed']) {
                _this.changeDetector.detectChanges();
            }
        }, 2000);
    };
    OldCarQuotationComponent.prototype.setIframeObserver = function (el) {
        var _this = this;
        if (el) {
            var element_1 = el.nativeElement;
            var observer = new MutationObserver(function (event) {
                if (element_1.classList.contains('mid') || element_1.classList.contains('full') || element_1.classList.contains('full-cover')) {
                    _this.isLoading = false;
                }
            });
            observer.observe(element_1, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false,
                characterData: false
            });
        }
    };
    return OldCarQuotationComponent;
}());
export { OldCarQuotationComponent };
